"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.MobileMenu = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _Modal = _interopRequireDefault(require("@material-ui/core/Modal"));
var _Backdrop = _interopRequireDefault(require("@material-ui/core/Backdrop"));
var _MenuList = _interopRequireDefault(require("@material-ui/core/MenuList"));
var _Paper = _interopRequireDefault(require("@material-ui/core/Paper"));
var _core = require("@material-ui/core");
var _clsx = _interopRequireDefault(require("clsx"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var useStyles = (0, _styles.makeStyles)(function (theme) {
  var _paperRoot;
  return {
    paperRoot: (_paperRoot = {
      position: "fixed",
      width: "100%",
      bottom: 0,
      borderRadius: "4px 4px 0px 0px",
      boxShadow: "0px 6px 20px rgba(0, 0, 0, 0.05), 0px 3px 15px rgba(0, 0, 0, 0.1), 0px 0px 8px rgba(0, 0, 0, 0.08)",
      maxHeight: "100vh"
    }, _defineProperty(_paperRoot, "maxHeight", "calc(var(--vh, 1vh) * 100)"), _defineProperty(_paperRoot, "overflowY", "auto"), _paperRoot)
  };
});
var MobileMenu = function MobileMenu(props) {
  var innerClasses = useStyles();
  var open = props.open,
    children = props.children,
    classes = props.classes,
    container = props.container,
    onClose = props.onClose,
    paperClasses = props.paperClasses;
  return /*#__PURE__*/_react.default.createElement(_Modal.default, {
    "aria-labelledby": "transition-modal-title",
    "aria-describedby": "transition-modal-description"
    // className={innerClasses.modal}
    ,
    container: container,
    open: open,
    onClose: onClose,
    closeAfterTransition: true,
    BackdropComponent: _Backdrop.default,
    BackdropProps: {
      timeout: 500
    },
    style: {
      zIndex: 2147483648
    }
  }, /*#__PURE__*/_react.default.createElement(_core.Slide, {
    in: open,
    direction: "up"
  }, /*#__PURE__*/_react.default.createElement(_Paper.default, {
    elevation: 0,
    classes: {
      root: (0, _clsx.default)(innerClasses.paperRoot, paperClasses)
    }
  }, /*#__PURE__*/_react.default.createElement(_MenuList.default, {
    autoFocusItem: open,
    id: "menu-list-grow",
    classes: classes
  }, children))));
};
exports.MobileMenu = MobileMenu;